import Typography from '@cobliteam/ui/components/Typography';

interface DataTableCellVehicleProps {
  licensePlate?: string | null;
  brand?: string | null;
  model?: string | null;
  groupName?: string;
  showGroupName?: boolean;
}

const DataTableCellVehicle = ({ brand, model, licensePlate, groupName, showGroupName = true }: DataTableCellVehicleProps) => {
  const newBrand = brand ? `- ${brand}` : '';
  const newModel = model ? `- ${model}` : '';
  const newLicensePlate = licensePlate ? ` ${licensePlate}` : '';
  const newLabel = `${newLicensePlate} ${newBrand} ${newModel}`;
  const newLabelWithFallback = newLabel.trim() || '---';

  return (
    <div className='flex flex-col gap-2'>
      <Typography title={newLabel} color='secondary' variant='description-title' className='line-clamp-1'>
        {newLabelWithFallback}
      </Typography>
      {showGroupName ? (
        <Typography title={groupName} color='secondary' variant='caption-default' className='line-clamp-1'>
          {groupName || '---'}
        </Typography>
      ) : null}
    </div>
  );
};

export default DataTableCellVehicle;
